/**
 * Main Nav — Submenu Keyboard/Hover Accessibility
 *
 * Applies to whichever always-visible nav lives inside .site-header
 * (today: td_get_menu()'s output, in header__default.php's inline
 * <nav>). Deliberately NOT tied to the mobile-nav override slot --
 * this keyboard/hover dropdown behavior is needed regardless of which
 * mobile-nav pattern a site uses (off-canvas today, a possible future
 * bottom-bar pattern later), since it's about the header's own inline
 * dropdown menu, not about the mobile pattern itself. Lives alongside
 * menu__walker.php as a plain, always-loaded core file, not an
 * override point.
 *
 * There's only ONE .site-header now (no desktop/mobile header split),
 * so this only ever needs one querySelector, not a cached pair like
 * the old menu__mobile.js did.
 *
 * Hidden (CSS display:none at mobile widths) elements are naturally
 * excluded from the tab/hover flow, so no viewport check is needed
 * here at all.
 */

(function () {
  "use strict";

  function setupSubmenuAccessibility(link, submenu, parent) {
    const submenuId =
      submenu.id || "nav-submenu-" + Math.random().toString(36).substr(2, 9);
    submenu.setAttribute("id", submenuId);
    link.setAttribute("aria-haspopup", "true");
    link.setAttribute("aria-expanded", "false");
    link.setAttribute("aria-controls", submenuId);

    link.addEventListener("keydown", (e) => {
      const isExpanded = link.getAttribute("aria-expanded") === "true";

      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        const newState = !isExpanded;
        link.setAttribute("aria-expanded", newState);

        if (newState) {
          const firstSubLink = submenu.querySelector("a");
          if (firstSubLink) {
            setTimeout(() => firstSubLink.focus(), 50);
          }
        }
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        if (!isExpanded) {
          link.setAttribute("aria-expanded", "true");
        }
        const firstSubLink = submenu.querySelector("a");
        if (firstSubLink) {
          setTimeout(() => firstSubLink.focus(), 50);
        }
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        if (!isExpanded) {
          link.setAttribute("aria-expanded", "true");
          const firstSubLink = submenu.querySelector("a");
          if (firstSubLink) {
            setTimeout(() => firstSubLink.focus(), 50);
          }
        }
      } else if (e.key === "Escape") {
        e.preventDefault();
        link.setAttribute("aria-expanded", "false");
        link.focus();
      }
    });

    const submenuItems = submenu.querySelectorAll("a");
    submenuItems.forEach((item, index) => {
      item.addEventListener("keydown", (e) => {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          const nextIndex = (index + 1) % submenuItems.length;
          submenuItems[nextIndex].focus();
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          if (index === 0) {
            link.focus();
            link.setAttribute("aria-expanded", "false");
          } else {
            submenuItems[index - 1].focus();
          }
        } else if (e.key === "Escape" || e.key === "ArrowLeft") {
          e.preventDefault();
          link.setAttribute("aria-expanded", "false");
          link.focus();
        }
      });
    });

    parent.addEventListener("mouseenter", () => {
      link.setAttribute("aria-expanded", "true");
    });

    parent.addEventListener("mouseleave", () => {
      if (!parent.contains(document.activeElement)) {
        link.setAttribute("aria-expanded", "false");
      }
    });

    parent.addEventListener("focusout", (e) => {
      if (!parent.contains(e.relatedTarget)) {
        link.setAttribute("aria-expanded", "false");
      }
    });
  }

  function init() {
    const siteHeader = document.querySelector(".site-header");
    if (!siteHeader) return;

    const submenuParentLinks = siteHeader.querySelectorAll(
      ".menu-item.has-children > a, .menu-item.has-children > .menu-item-text",
    );

    submenuParentLinks.forEach((link) => {
      const parent = link.closest(".menu-item");
      const submenu = parent.querySelector(".sub-menu");
      if (submenu) {
        setupSubmenuAccessibility(link, submenu, parent);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
